(function () {
  "use strict";

  function initCarousel(section) {
    var container = section.querySelector(".reviews-carousel-swiper");
    if (!container || container.swiper) return;

    var prevButton = section.querySelector(".global-nav-button.prev, .nav-button.prev");
    var nextButton = section.querySelector(".global-nav-button.next, .nav-button.next");

    var swiperLoad =
      typeof window.swiperCheckAndLoad === "function"
        ? window.swiperCheckAndLoad()
        : Promise.resolve();

    swiperLoad.then(function () {
      if (!container || container.swiper) return;
      if (typeof window.Swiper === "undefined") return;

      container.classList.remove("reviews-carousel-swiper--pending");

      var spaceBetween = 20;
      var slidesPerViewMobile = "auto";
      var centerDesktop = section.dataset.centerCardsDesktop === 'true';
      var centerMobile = section.dataset.centerCardsMobile === 'true';
      var slideCount = container.querySelectorAll('.swiper-slide').length;
      var isMobile = window.innerWidth < 768;
      var shouldCenter = isMobile ? centerMobile : centerDesktop;
      var initialSlide = shouldCenter ? Math.floor(slideCount / 2) : 0;

      var breakpoints = {};
      breakpoints[768] = { 
        spaceBetween: spaceBetween, 
        slidesPerView: "auto",
        centeredSlides: centerDesktop,
        centeredSlidesBounds: centerDesktop,
        centerInsufficientSlides: centerDesktop
      };

      var swiperConfig = {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: spaceBetween,
      loop: false,
      speed: 400,
      centeredSlides: centerMobile,
      centeredSlidesBounds: centerMobile,
      centerInsufficientSlides: centerMobile,
      initialSlide: initialSlide,
        navigation: {
          prevEl: prevButton,
          nextEl: nextButton,
          hideOnClick: false,
          disabledClass: "nav-button-disabled"
        },
        breakpoints: breakpoints,
        observer: true,
        observeParents: true
      };

      var swiper = new window.Swiper(container, swiperConfig);

      swiper.on('breakpoint', function() {
        setTimeout(function() {
          var isDesktop = window.innerWidth >= 768;
          var shouldCenter = isDesktop ? centerDesktop : centerMobile;
          var targetSlide = shouldCenter ? Math.floor(slideCount / 2) : 0;
          swiper.slideTo(targetSlide, 0, false);
        }, 50);
      });
    });
  }

  function initReadMore(section) {
    section.querySelectorAll(".review-card").forEach(function (card) {
      var review = card.querySelector(".review-text");
      var button = card.querySelector(".review-read-more");
      if (!review || !button) return;

      if (!button.dataset.readMoreBound) {
        button.addEventListener("click", function () {
          var expanded = review.classList.toggle("is-expanded");
          button.setAttribute("aria-expanded", String(expanded));
          button.textContent = expanded ? "Read less" : "Read more";
        });
        button.dataset.readMoreBound = "true";
      }

      if (review.classList.contains("is-expanded")) return;
      button.hidden = review.scrollHeight <= review.clientHeight + 1;
    });
  }

  function runInit() {
    var sections = document.querySelectorAll(".reviews-transformation-section");
    sections.forEach(function (section) {
      if (section.querySelector(".reviews-carousel-swiper")) {
        initReadMore(section);
        initCarousel(section);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }

  window.addEventListener("resize", function () {
    document.querySelectorAll(".reviews-transformation-section").forEach(initReadMore);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      document.querySelectorAll(".reviews-transformation-section").forEach(initReadMore);
    });
  }

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector && e.target.querySelector(".reviews-transformation-section");
    if (section) {
      initReadMore(section);
      initCarousel(section);
    } else if (e.target.classList && e.target.classList.contains("reviews-transformation-section")) {
      initReadMore(e.target);
      initCarousel(e.target);
    }
  });
})();